import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Droplets, Wrench, Hammer, Flame, Bath, Search, AlertCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const iconMap = {
  Droplets,
  Wrench,
  Hammer,
  Flame,
  Bath,
  Search,
  AlertCircle
};

const ServiceCard = ({ service, detailed = false }) => {
  const IconComponent = iconMap[service.icon] || Wrench;

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-[#2F80ED] h-full">
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
            service.urgent 
              ? 'bg-red-100 text-red-600 group-hover:bg-red-600 group-hover:text-white' 
              : 'bg-[#2F80ED]/10 text-[#2F80ED] group-hover:bg-[#2F80ED] group-hover:text-white'
          }`}>
            <IconComponent className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-lg text-[#0B2A4A] mb-2 group-hover:text-[#2F80ED] transition-colors">
              {service.title}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-4">
              {service.description}
            </p>
            {detailed && service.price && (
              <p className="text-sm font-semibold text-[#2F80ED] mb-4">
                {service.price}
              </p>
            )}
            {detailed ? (
              <Link to="/contact">
                <Button 
                  variant="outline" 
                  className="w-full border-[#2F80ED] text-[#2F80ED] hover:bg-[#2F80ED] hover:text-white transition-all duration-300"
                >
                  Demander un devis
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            ) : (
              <Link 
                to="/services" 
                className="inline-flex items-center text-sm font-medium text-[#2F80ED] hover:gap-2 transition-all duration-300 group"
              >
                En savoir plus
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </Link>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
